import React from "react";
import { useNavigate } from "react-router-dom";

const order = {
  orderId: "LDR-002142",
  date: "10 Jan 2025",
  status: "Delivered",
  details: {
    orderId: "LDR-002142",
    bagBarcode: "BAG-78212",
    orderDate: "10 Jan 2025",
    completedOn: "10 Jan 2025",
    items: ["2 x Shirts", "2 x T-Shirt", "4 x Trousers"],
    pickupLocation: "Location",
  },
};

export default function OrderDetailsScreen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-5 pt-10 pb-4 flex flex-col">
      {/* Header */}
      <div className="mb-2">
        <h2 className="text-2xl font-bold text-[#172B3A] mb-1">
          Order Submitted
        </h2>
        <p className="text-[#6B7280] text-base mb-2">
          Stay updated with your laundry process
        </p>
        <div className="flex items-center gap-2 mb-2">
          <span className="font-semibold text-[#172B3A]">Order ID</span>
          <span className="text-[#6B7280]">{order.orderId}</span>
        </div>
      </div>

      {/* Status Progress */}
      <div className="mt-4">
        <div className="flex flex-col gap-2 mb-1">
          <span className="font-semibold text-[#172B3A] mb-1">
            Order Received
          </span>
          <div className="flex flex-row gap-2 w-full mb-2">
            <span className="h-1.5 rounded bg-gray-200 flex-1" />
            <span className="h-1.5 rounded bg-gray-200 flex-1" />
            <span className="h-1.5 rounded bg-gray-200 flex-1" />

            <span className="h-1.5 rounded bg-gray-200 flex-1" />
          </div>
        </div>
        <div className="text-[#6B7280] text-sm mb-2">12 Dec, 10:32 AM</div>
      </div>

      {/* Vector Image */}
      <div
        className="bg-[#E6F6FA] rounded-xl flex items-center justify-center mb-8"
        style={{ minHeight: 180 }}
      >
        <img
          src={require("../assets/png/track-order-vector.png")}
          alt="Order Tracking"
          className="w-90 h-90 object-contain"
        />
      </div>

      {/* Bottom Button */}
      <div className="mt-auto">
        <button
          className="w-full bg-[#3CB3D6] text-white font-semibold py-4 rounded-full text-lg shadow-md"
          onClick={() => navigate("/dashboard")}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
